import API from '../../../utils/API';
import { Post, Get, Put, Patch, Delete } from '../../../utils/callApi';

import jwt_decode from "jwt-decode";

import { 
  NOT_FOUND_MAIL_MESSAGE,
  OTP_WRONG_MESSAGE,
  SEND_MAIL_ERROR_MESSAGE,
  ACCOUNT_IS_LOCKED,
  NOT_FOUND_OTP_MESSAGE,
  OVER_TIME_GET_OTP_MESSAGE,
  OVER_TIME_SEND_OTP_MESSAGE,
} from '../../../utils/constants';


export const sendmail = async (body) => {
  const { success, data } = await Post(API.LOGIN.GET_OTP, body);
  
  if(success) {
    if(data.ErrorCode === 0){
      return {
        success: true,
        data: data.Result,
      };
    }
    if(data.ErrorCode === 410){
      return {
        success: false,
        data: { error: NOT_FOUND_MAIL_MESSAGE },
      };
    }

    if(data.ErrorCode === 411){
      return {
        success: false,
        data: { error: ACCOUNT_IS_LOCKED },
      };
    }

    if(data.ErrorCode === 412){
      return {
        success: false,
        data: { error: SEND_MAIL_ERROR_MESSAGE },
      };
    }

    if(data.ErrorCode === 415){
      return {
        success: false,
        data: { error: ACCOUNT_IS_LOCKED },
      };
    }

    return {
      success: false,
      data: {error: SEND_MAIL_ERROR_MESSAGE},
    }
  } else {
    return {
      success: false,
      data: {error: SEND_MAIL_ERROR_MESSAGE}
    };
  }
}

export const getotp = async (body) => {
  const { success, data } = await Post(API.LOGIN.REGET_OTP, body);

  if(success) {
    if(data.ErrorCode === 0){
      return {
        success: true,
        data: data.Result,
      };
    }

    if(data.ErrorCode === 410){
      return {
        success: false,
        data: { error: NOT_FOUND_OTP_MESSAGE },
      };
    }

    if(data.ErrorCode === 411){
      return {
        success: false,
        data: { error: OVER_TIME_SEND_OTP_MESSAGE },
      };
    }

    if(data.ErrorCode === 412){
      return {
        success: false,
        data: {error: SEND_MAIL_ERROR_MESSAGE},
      };
    }

    if(data.ErrorCode === 415){
      return {
        success: false,
        data: {error: ACCOUNT_IS_LOCKED },
      };
    }

    return {
      success: false,
      data: {error: SEND_MAIL_ERROR_MESSAGE},
    }
  } else {
    return {
      success: false,
      data: {error: SEND_MAIL_ERROR_MESSAGE}
    };
  }
}

export const sendotp = async (body) => {
  const { success, data } = await Post(API.LOGIN.SENT_OTP, body);

  if(success) {
    if(data.ErrorCode === 0){
      const decoded = jwt_decode(data.Result.token);
      return {
        success: true,
        data: {
          ...data.Result,
          menu: data.Result.menu.sort((a, b) => a.permission._id.localeCompare(b.permission._id)),
          user: {...decoded.payload, exp: decoded.exp},
        },
      };
    }
    if(data.ErrorCode === 412){
      return {
        success: false,
        data: {error: OTP_WRONG_MESSAGE},
      }
    }
    if(data.ErrorCode === 415) {
      return {
        success: false,
        data: {error: ACCOUNT_IS_LOCKED},
      }
    }
    return {
      success: false,
      data: {error: OTP_WRONG_MESSAGE}
    };
  } else {
    return {
      success: false,
      data: {error: OTP_WRONG_MESSAGE}
    };
  }
}